module.exports = __webpack_public_path__ + "img/screen_14.63a03089.svg";